import { gsap } from "@gsap";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.statistics-layout").forEach((layout) => {
        const numbers = gsap.utils.toArray(".stat-number", layout);
        if (!numbers.length) return;

        const mm = gsap.matchMedia();

        mm.add("(prefers-reduced-motion: no-preference)", () => {
            numbers.forEach((el, index) => {
                const target = el.dataset.count;
                const end = parseFloat(target);
                if (Number.isNaN(end)) return;

                const decimals = (target.split(".")[1] || "").length;
                const counter = { value: 0 };
                el.textContent = (0).toFixed(decimals);

                gsap.to(counter, {
                    value: end,
                    duration: 1.2,
                    delay: index * 0.1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: layout,
                        start: "top 80%",
                        once: true,
                    },
                    onUpdate: () => {
                        el.textContent = counter.value.toFixed(decimals);
                    },
                    onComplete: () => {
                        el.textContent = target;
                    },
                });
            });

            return () => {
                numbers.forEach((el) => {
                    el.textContent = el.dataset.count;
                });
            };
        });
    });
});
